import { AdminUserModel, UserStatisticSummary } from "../../../infrastructure/model/AppUserModel";
import { UserService } from "../../../infrastructure/services/UserService";
import { PageResponse } from "../../constants/AppTypes";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const findUserByPageUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    page: number;
    limit: number;
    userName: string;
  }
): Promise<PageResponse<AdminUserModel[]>> => {
  const { page, limit, userName, setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: PageResponse<AdminUserModel[]> = {
      total: 0,
      data: [],
    };
    const res = await UserService.findUserByPage(page, limit, userName);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = {
          data: res.data.data,
          total: res.data.total,
        };
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const getUserStatisticSummaryUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    userId: number;
  }
): Promise<UserStatisticSummary | undefined> => {
  const { userId, setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: UserStatisticSummary | undefined = undefined;
    const res = await UserService.getUserStatisticSummary(userId);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
